import React, { useState, useEffect } from 'react';
import Navbar from './layout/Navbar';
import Slider from 'react-slick';
import Footer from './layout/Fotter';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link, useNavigate } from 'react-router-dom';

// Image imports
import image1 from '../assets/image1.jpg';
import image14 from '../assets/image14.jpg';
import image17 from '../assets/image17.jpg';
import image19 from '../assets/image19.avif';
import image9 from '../assets/image9.png';
import image10 from '../assets/image10.jpg';
import image12 from '../assets/image12.jpg';
import image13 from '../assets/image13.jpg';
import image16 from '../assets/image16.webp';
import image15 from '../assets/image15.jpg';
import { Headphones, Layers, Medal, MoveRight, UserCheck } from 'lucide-react';

const Home = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  // Page load par top par scroll karein
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Slider settings with responsive breakpoints
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          arrows: false,
          dots: true,
        },
      },
      {
        breakpoint: 640,
        settings: {
          arrows: false,
          dots: false,
        },
      },
    ],
  };

  // Product categories data
  const productCategories = [
    {
      id: 1,
      image: image9,
      title: "FLOOR ",
      fullName: "Floor Vitrified Tiles",
      description: "Premium quality glazed vitrified tiles with exceptional durability and water resistance.",
      features: ["Water Absorption < 0.5%", "High Strength", "Stain Resistant", "Easy Maintenance"],
      sizes: ["600x1200mm", "600x600mm"],
      route: "/floor",
    },
    {
      id: 2,
      image: image10,
      title: "PORCELAIN SLAB",
      fullName: "Polished Glazed Vitrified Tiles",
      description: "Mirror-like finish tiles that add elegance and spaciousness to any interior space.",
      features: ["Mirror Finish", "Scratch Resistant", "Light Reflective", "Premium Quality"],
      sizes: ["800x200mm", "800x3200mm", "1200x2400mm", "1200x3200mm"],
      route: "/porcelain-slab",
    },
    {
      id: 3,
      image: image12,
      title: "WALL TILES",
      fullName: "Wall Finish Tiles",
      description: "Sophisticated non-reflective surface tiles perfect for contemporary interiors.",
      features: ["Anti-Slip Surface", "Fingerprint Resistant", "Contemporary Look", "Low Maintenance"],
      sizes: ["300x450mm", "300x600mm"],
      route: "/wall",
    },
    // {
    //   id: 4,
    //   image: image13,
    //   title: "HIGH GLOSS",
    //   fullName: "High Gloss Ceramic Tiles",
    //   description: "Ultra-glossy finish tiles that create a luxurious and modern aesthetic.",
    //   features: ["Ultra Glossy Finish", "Easy to Clean", "Luxurious Appeal", "Color Retention"],
    //   sizes: ["30x120mm", "29x180mm", "19.5x120mm"],
    //   route: "/high-gloss",
    // },
    {
      id: 5,
      image: image16,
      title: "ELEVATION",
      fullName: "Elevation Design Tiles",
      description: "Artistic carved tiles with intricate patterns for decorative and accent applications.",
      features: ["3D Texture", "Artistic Patterns", "Decorative Appeal", "Unique Designs"],
      sizes: ["40x40mm", "29x180mm", "120x240mm"],
      route: "/elevation",
    },
    // {
    //   id: 6,
    //   image: image15,
    //   title: "WOODEN",
    //   fullName: "Wood Look Ceramic Tiles",
    //   description: "Natural wood appearance with the durability and practicality of ceramic material.",
    //   features: ["Natural Wood Look", "Water Resistant", "Termite Proof", "Long Lasting"],
    //   sizes: ["80x240mm", "13x80mm", "40x40mm"],
    //   route: "/wooden",
    // },
  ];

  // Available tile sizes data with routes
  // const availableSizes = [
  //   { size: "80x240mm", route: "/gvt" },
  //   { size: "120x80mm", route: "/pgvt" },
  //   { size: "80x80mm", route: "/matt" },
  //   { size: "60x60mm", route: "/carving" },
  //   { size: "30x120mm", route: "/high-gloss" },
  //   { size: "20x120mm", route: "/wooden" },
  //   { size: "100x100mm", route: "/bedroom" },
  //   { size: "120x240mm", route: "/bathroom" },
  //   { size: "120x120mm", route: "/leaving-area" },
  //   { size: "60x120mm", route: "/kitchen" },
  //   { size: "13x80mm", route: "/outdoor" },
  //   { size: "29x180mm", route: "/counter-tops" },
  //   { size: "40x40mm", route: "/commercial-space" },
  //   { size: "30x30mm", route: "/stairs-tils" },
  //   { size: "19.5x120mm", route: "/bedroom" },
  //   { size: "80x260mm", route: "/pgvt" },
  // ];

  // Function to prevent right-click and dragging
  const preventDefault = (e) => {
    e.preventDefault();
  };

  // Handle click for all View Collection buttons with loader and scroll to top
  const handleCollectionClick = (route) => {
    setIsLoading(true);

    // Pehle top par scroll karein - instant
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });

    setTimeout(() => {
      setIsLoading(false);
      navigate(route);

      // Navigation ke baad bhi ensure karein ke naye page par top par scroll ho
      setTimeout(() => {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'instant'
        });
      }, 100);
    }, 2000);
  };

  // Handle click for all size buttons with loader and scroll to top
  const handleSizeClick = (route) => {
    setIsLoading(true);

    // Pehle top par scroll karein - instant
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });

    setTimeout(() => {
      setIsLoading(false);
      navigate(route);

      // Navigation ke baad bhi ensure karein ke naye page par top par scroll ho
      setTimeout(() => {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'instant'
        });
      }, 100);
    }, 2000);
  };

  return (
    <div className="w-full overflow-hidden">
      {/* Loader Overlay */}
      {isLoading && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
          <div className="flex flex-col items-center">
            <div className="relative">
              <div className="w-20 h-20 border-4 border-transparent rounded-full animate-spin"
                style={{
                  background: 'conic-gradient(from 0deg, #ff6b00, #f7e101, #ff6b00)',
                  WebkitMask: 'radial-gradient(circle at center, transparent 40%, black 41%)'
                }}>
              </div>
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-12 h-12 bg-orange-600 rounded-full animate-pulse"></div>
              </div>
            </div>
            <p className="mt-6 text-white text-2xl font-bold animate-bounce tracking-wide">
              GMC Ceramic
            </p>
          </div>
        </div>
      )}

      {/* Navbar */}
      <Navbar />

      {/* Hero Slider Section */}
      <div className="w-full relative">
        <Slider {...settings}>
          {[image1, image14, image17, image19].map((img, index) => (
            <div key={index} className="relative">
              <img
                src={img}
                alt={`slide-${index}`}
                className="w-full h-[55vh] sm:h-[65vh] md:h-[75vh] lg:h-[90vh] object-cover select-none"
                onContextMenu={preventDefault}
                onDragStart={preventDefault}
                style={{ userSelect: 'none', WebkitUserSelect: 'none', MozUserSelect: 'none' }}
              />
              <div className="absolute inset-0 z-10" onContextMenu={preventDefault}></div>
              <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-start z-20">
                <div className="ml-4 sm:ml-8 md:ml-12 lg:ml-16 text-white max-w-full sm:max-w-md md:max-w-lg lg:max-w-2xl px-4 select-none">
                  <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-orange-500 drop-shadow-2xl mb-2 sm:mb-4">
                    GMC CERAMIC
                  </h1>
                  <p className="text-base sm:text-lg md:text-xl lg:text-2xl font-light mb-4 sm:mb-6 leading-relaxed">
                    Transform Your Space with Premium Quality Tiles
                  </p>
                  <div className="flex flex-col sm:flex-row gap-2 sm:gap-4">
                    <Link to="/gvt">
                      <button className="bg-orange-600 hover:bg-orange-700 text-white px-4 sm:px-6 py-2 sm:py-3 rounded-lg text-sm sm:text-base lg:text-lg font-semibold transition-all duration-300 transform hover:scale-105">
                        Explore Collection
                      </button>
                    </Link>
                    <Link to="/contact">
                      <button className="border-2 border-white text-white hover:bg-white hover:text-orange-600 px-4 sm:px-6 py-2 sm:py-3 rounded-lg text-sm sm:text-base lg:text-lg font-semibold transition-all duration-300">
                        Contact Us
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>

      {/* Available Sizes Section */}
      {/* <section className="py-6 sm:py-8 lg:py-10 bg-white select-none">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-4 sm:mb-6">
            <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800 mb-2">
              Available <span className="text-orange-600">Tile Sizes</span>
            </h2>
            <p className="text-sm sm:text-base text-gray-600">
              Choose from our wide range of sizes to fit your perfect space
            </p>
          </div> */}
      {/* <div className="flex flex-wrap justify-center gap-2 sm:gap-3 lg:gap-4 max-w-5xl mx-auto">
            {availableSizes.map((item, index) => (
              <button
                key={index}
                onClick={() => handleSizeClick(item.route)}
                className="bg-gradient-to-br from-orange-50 to-orange-100 border-2 border-orange-200 rounded-lg px-3 sm:px-4 py-2 sm:py-3 shadow-sm hover:shadow-md transition-all duration-300 transform hover:scale-105 min-w-[100px] max-sm:min-w-[120px] sm:min-w-[140px] lg:min-w-[160px] h-10 sm:h-12 flex items-center justify-center"
                disabled={isLoading}
              >
                <span className="text-sm sm:text-base font-semibold text-gray-800">
                  {item.size}
                </span>
              </button>
            ))}
          </div> */}
      {/* </div>
      </section > */}

      {/* About Section */}
      < section className="py-8 sm:py-12 lg:py-16 bg-gradient-to-r from-orange-50 to-orange-100 select-none" >
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-3 sm:mb-4">
              Why Choose <span className="text-orange-600">GMC Ceramic?</span>
            </h2>
            <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              With over a decade of excellence in ceramic manufacturing, we bring you world-class tiles that combine durability, beauty, and innovation.
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
            {[
              {
                title: "Premium Quality",
                desc: "ISO certified manufacturing with international quality standards",
                icon: <Medal className='mx-auto h-7 w-7 sm:h-10 sm:w-10' />,
              },
              {
                title: "Wide Range",
                desc: "Extensive collection of designs, sizes, and finishes",
                icon: <Layers className='mx-auto h-7 w-7 sm:h-10 sm:w-10' />,
              },
              {
                title: "Expert Support",
                desc: "Professional guidance and installation support",
                icon: <UserCheck className='mx-auto h-7 w-7 sm:h-10 sm:w-10' />,
              },
            ].map((item, index) => (
              <div
                key={index}
                className="text-center p-4 sm:p-6 bg-white rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300 select-none"
              >
                <div className="w-12 h-12 sm:w-16 sm:h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                  <span className="text-orange-600 text-lg sm:text-2xl font-bold">{item.icon}</span>
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-gray-800 mb-2">{item.title}</h3>
                <p className="text-sm sm:text-base text-gray-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section >

      {/* Product Categories Section */}
      < section className="py-8 sm:py-12 lg:py-16 bg-gray-50 select-none" >
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-3 sm:mb-4">
              Our <span className="text-orange-600">Product Categories</span>
            </h2>
            <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-2xl mx-auto">
              Discover our comprehensive range of premium ceramic tiles designed for every space and style
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
            {productCategories.map((category) => (
              <div
                key={category.id}
                className="bg-white rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 overflow-hidden group select-none"
              >
                <div className="relative overflow-hidden">
                  <img
                    src={category.image}
                    alt={category.title}
                    className="w-full h-48 sm:h-56 md:h-64 object-cover group-hover:scale-110 transition-transform duration-500 select-none"
                    onContextMenu={preventDefault}
                    onDragStart={preventDefault}
                    style={{ userSelect: 'none', WebkitUserSelect: 'none', MozUserSelect: 'none' }}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  <div className="absolute inset-0 z-10" onContextMenu={preventDefault}></div>
                </div>
                <div className="p-4 sm:p-6">
                  <div className="mb-3 sm:mb-4">
                    <h3 className="text-xl sm:text-2xl font-bold text-orange-600 mb-1">{category.title}</h3>
                    <h4 className="text-xs sm:text-sm text-gray-500 font-medium">{category.fullName}</h4>
                  </div>
                  <p className="text-sm sm:text-base text-gray-600 mb-4 leading-relaxed">{category.description}</p>
                  <div className="mb-4 sm:mb-6">
                    <h5 className="font-semibold text-gray-800 text-sm sm:text-base mb-2">Available Sizes:</h5>
                    <div className="flex flex-wrap gap-2">
                      {category.sizes.map((size, index) => (
                        <span
                          key={index}
                          className="bg-gray-100 text-gray-700 text-xs sm:text-sm px-2 py-1 rounded border"
                        >
                          {size}
                        </span>
                      ))}
                    </div>
                  </div>
                  <button
                    onClick={() => handleCollectionClick(category.route)}
                    className="w-full bg-orange-600 hover:bg-orange-700 text-white font-semibold py-2.5 sm:py-3 px-4 sm:px-6 rounded-lg text-sm sm:text-base transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2"
                    disabled={isLoading}
                  >
                    View Collection
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section >

      {/* CTA Section */}
      < section className="py-8 sm:py-12 lg:py-16 bg-gradient-to-r from-orange-50 to-orange-100 text-gray-800 select-none" >
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-4 sm:mb-6">
            Ready to Transform Your Space?
          </h2>
          <p className="text-base sm:text-lg md:text-xl mb-6 sm:mb-8 max-w-2xl mx-auto leading-relaxed">
            Get in touch with our experts for personalized recommendations and professional guidance
          </p>
        </div>
      </section >

      {/* Footer */}
      < Footer />
    </div >
  );
};

export default Home;